import * as React from 'react';

interface EmployeeResult {
  employee: {
    id: string;
    name: string;
    roles: { id: string; name: string }[];
  } | null;
  setEmployee: (
    value: {
      id: string;
      name: string;
      roles: { id: string; name: string }[];
    } | null,
  ) => void;
}

const context = React.createContext<EmployeeResult>({
  employee: { id: '', name: '', roles: [] },
  setEmployee() {},
});

const { Provider } = context;

interface EmployeeProviderProps {
  children: React.ReactNode;
}

export function EmployeeProvider(props: EmployeeProviderProps) {
  const [employee, setState] = React.useState<{
    id: string;
    name: string;
    roles: { id: string; name: string }[];
  } | null>(null);
  const setEmployee = React.useCallback(
    async (
      value: {
        id: string;
        name: string;
        roles: { id: string; name: string }[];
      } | null,
    ) => {
      setState(value);
      if (window) {
        localStorage.setItem('employee', JSON.stringify(value));
      }
    },
    [],
  );

  return (
    <Provider value={{ employee, setEmployee }}>{props.children}</Provider>
  );
}

export function useEmployee() {
  return React.useContext(context);
}
